export const PROGRESSION_LEVELS = [
  'beginner',
  'lower_intermediate',
  'intermediate',
  'upper_intermediate',
  'advanced',
];

export const MOVEMENT_CATEGORIES = [
  'balance',
  'edging',
  'rotation',
  'pressure',
  'timing_coordination',
  'freestyle',
  'freeride_terrain',
];

export const LESSON_STAGE_KEYS = [
  'review',
  'stationary_feel',
  'base_drill',
  'progression_drill',
  'application_drill',
];

export const DISCIPLINE_HINTS = [
  'all_mountain_fundamentals',
  'carving',
  'freeride_powder',
  'freestyle_park',
  'steeps',
  'bumps',
];
